import { Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./SummaryCard.css";
import CustomTooltip from "../Components/Modals/CustomTooltip";
import { primaryShades, variantTokens, greyScaleTokens } from "../../theme/theme";
import { formatNumberBritish, isTimeField } from "../../utils/numberFormatting";

// Costanti dei colori
const PRIMARY_300 = primaryShades.primary300;
const WHITE = variantTokens.white;
const GREY_200 = greyScaleTokens.grey200;

function SummaryCard({ active, label, value, percentage, onClick, loading, toolTipText = "Info on this card", index, totalitems }) {
    const isLast = index === totalitems - 1;

    return (
        <div
            onClick={onClick}
            style={{
                flex: 1,
                padding: 'clamp(0.9375rem, 4vw, 1.875rem) clamp(0.625rem, 3vw, 1.25rem)',
                cursor: 'pointer',
                backgroundColor: active ? PRIMARY_300 : WHITE,
                color: active ? WHITE : PRIMARY_300,
                borderRight: isLast ? 'none' : `clamp(0.0625rem, 0.2vw, 0.0625rem) solid ${GREY_200}`,
                border: `clamp(0.0625rem, 0.2vw, 0.0625rem) solid ${GREY_200}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                textAlign: 'center',
                position: 'relative',
                height: '100%',
                width: '100%'
            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    cursor: "pointer",
                }}
            >
                <CustomTooltip title={toolTipText}>
                    <InfoCircleOutlined style={{ fontSize: '1rem', color: active ? WHITE : PRIMARY_300 }} />
                </CustomTooltip>
            </div>
            <div style={{
                fontSize: 'clamp(2rem, 6vw, 3rem)',
                fontWeight: 'bold',
                color: active ? WHITE : PRIMARY_300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'clamp(0.25rem, 1vw, 0.5rem)',
                height: 'clamp(3rem, 7vh, 4rem)', // Altezza fissa invece di minHeight
                width: '100%'
            }}>
                {loading ? (
                    <Spin
                        className={active ? "white-spin" : ""}
                        style={{
                            fontSize: 'clamp(1.5rem, 4vw, 2rem)' // Dimensione fissa per lo spinner
                        }}
                    />
                ) : (
                    <>
                        <span>
                            {isTimeField(label) ? value :
                                (label && label.toLowerCase().includes('avg s/u')) ?
                                    formatNumberBritish(value, 2) :
                                    formatNumberBritish(value, 0)}
                        </span>
                        {percentage && (
                            <span style={{
                                fontSize: 'clamp(0.875rem, 2.5vw, 1.125rem)',
                                fontWeight: 'normal',
                                opacity: 0.8
                            }}>
                                ({percentage}%)
                            </span>
                        )}
                    </>
                )}
            </div>
            <div style={{
                fontSize: 'clamp(0.875rem, 2.5vw, 1.125rem)',
                fontWeight: 'bold',
                marginTop: 0,
                color: active ? WHITE : PRIMARY_300,
                textTransform: 'uppercase',
                height: 'clamp(1.5rem, 3vh, 2rem)', // Altezza fissa invece di minHeight
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                {label}
            </div>
        </div>
    );
}

export default SummaryCard;